// SCSS imports
import {
  s0L1, s0L2, s0L3, s0L4,
  s1L1, s1L2, s1L3, s1L4,
  s2L1, s2L2, s2L3, s2L4,
  s3L1, s3L2, s3L3, s3L4,
  s4L1, s4L2, s4L3, s4L4,
  s5L1, s5L2, s5L3, s5L4,
  s6L1, s6L2, s6L3, s6L4,
  gL1, gL2, gL3, gL4
} from '../styles/modules/Chart.module.scss';

export const defaultColorCls = [s0L1, s0L2, s0L3, s0L4];

export const barColorCls = [
  [s1L1, s1L2, s1L3, s1L4],
  [s2L1, s2L2, s2L3, s2L4],
  [s3L1, s3L2, s3L3, s3L4],
  [s4L1, s4L2, s4L3, s4L4],
  [s5L1, s5L2, s5L3, s5L4],
  [s6L1, s6L2, s6L3, s6L4]
];

export const requiredColorCls = [gL1, gL2, gL3, gL4];
